<template>
    <div class="product-training">
        <div class="expert-div-lead text-center">
            <div class="expert-responsive-lead">
                    <h3><span>EXPERT IN</span><strong>HIGH-VISIBILITY APPAREL</strong></h3>
                    <img src="/images/st-learning/hi-vis/exp-main-hivis.png" alt="hand protection">
            </div>
            <div class="expert-div-info" ref="mobileView">
                <h2 style="padding-top:50px;">Be Seen, Be Safe & Warm</h2>
                <p class="mt1rem">
                    Roadwork, construction and emergency response  are not limited to the daytime, and it is essential to be easily seen in all light conditions. PIP has been a leader in  High-Visibility garments for all applications where workers are at risk. Being seen is important and so is staying warm and dry. PIP offers garments for all climates, from lightweight vests through to warm winter jackets, to keep workers safe and seen no matter what the conditions.
                </p>
                <img src="/images/st-learning/hi-vis/img-exp-hivis-main.jpg" alt="hi-visibility vest" style="margin-left:-50px; margin-bottom:40px;"/>
            </div>
            <a href="javascript:void(0);" class="expert-read-info">
                <span @mousedown="showMobile" ref="readMore"><small>READ MORE</small><font-awesome-icon :icon="['fas', 'chevron-down']" /></span>
                <span @mousedown="hideMobile" ref="readLess"><small>CLOSE</small><font-awesome-icon :icon="['fas', 'chevron-up']" /></span>
            </a>
        </div>

        <div class="expert-div">
            
            <h2 class="space" id="expert-h2-heading">Understanding<br />the ANSI Standard</h2>

            <p class="main">
                The ANSI/ISEA 107-2015 is now the approved standard for High-Visibility Safety Apparel and Accessories offering garment categories of performance classes. These classes are based on worker hazards and tasks, the complexity of the job site's background and vehicular traffic and speed.
            </p>

            <h2>Garment Categories</h2>

            <p class="main"></p>

            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ansi-type-o.jpg" alt="hi-vis type O"  />
                        <p>
                            <strong>Type O</strong><br />
                            Meant for off-road applications, Type 0 provides added visibility to workers who are not exposed to traffic. Type O HVSA provides daytime and nighttime environments which pose struck-by hazards from moving vehicles, equipment and machinery.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ansi-type-r.jpg" alt="hi-vis type R"/>
                        <p>
                            <strong>Type R</strong><br />
                            Enhanced visibility for workers who are exposed to highway traffic and working against complex backgrounds durnig daytime and nighttime environments. This includes exposure to vehicles using the highway for purposes of travel, roadway temporary traffic control (TTC) zones or from work vehicles and construction equipment within a roadway temporary traffic control (TTC) zone.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ansi-type-p.jpg" alt="hi-vis type P" />
                        <p>
                            <strong>Type P</strong><br />
                            Enhanced visibility for emergency and incident responders and law enforcement personnel in both roadway and off-road environments. The standard requires less flourescent background material in order to incoporate colored panels to easily identify and distinguish personnel. It also permits for shorter garments in order to make tactical access to equipment belts easier and safer.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>


            <h2 style="margin-top:30px; padding-top:40px; border-top:1px solid #ccc;">Performance Classes </h2>


            <div id="material-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ansi-class-1.jpg" style="width:184px; height:auto;" alt="ANSI 107 - Type/Class 01" />
                        <p>
                            <strong>Performance Class 1</strong><br />
                            <em>Type O Only</em><br /><br />
                            Provides the minimum amount of high-visibility materials required to differentiate the wearer visually from noncomplex work environments, in scenarios in which the struck-by hazards will not be approaching at roadway speeds, and therefore operative detection and identification distances.
                        </p>

                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ansi-class-2.jpg" style="width:184px; height:auto;" alt="ANSI 107 - Type/Class P2 and R2"/>
                        <p>
                            <strong>Performance Class 2</strong><br />
                            <em>Type R & Type P</em><br /><br />Provides for the use of additional amounts of high-visibility materials, which may allow design opportunities to define the human form more effectively. Performance Class 2 HVSA have the potential to provide longer detection and identification distances, and increased conspicuity performance compared to Performance Class 1 HVSA.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ansi-class-3.jpg" style="width:184px; height:auto;" alt="ANSI 107 - Type/Class R3 and P3" /><p><strong>Performance Class 3</strong><br />
                        <em>Type R & Type P</em><br /><br />
                        Performance Class 3 can offer greater visibility to the wearer in both complex backgrounds and through a full range of body movements by mandatory placement of background, retroreflective and combined-performance materials on sleeves and pant legs (if present).Regardless of the area of materials used, a sleeveless garment or vest alone shall not be considered Performance Class 3.</p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ansi-class-e.jpg" style="width:184px; height:auto;" alt="ANSI 107 - Type/Class E" />
                        <p>
                            <strong>Supplemental Class E</strong><br /><br />
                            Class E apparel includes pants, bib overalls, shorts, and gaiters. These garments are not compliant when they are worn alone, though, when combined with Class 2 or Class 3 apparel, the combination satisfies Class 3 requirements.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <!-- <p class="expert-link">
                <a href="https://www.amazon.com/stores/page/543ACA2A-20AE-4A4A-800E-BB61C4257567/search?ingress=2&visitId=d819cc99-3044-4077-8512-7e9ab5cfb075&ref_=ast_bln&terms=hi%20vis">View all High-Visibility Clothing products ></a>
            </p> -->

        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider"/>

        <div class="expert-div" id="hivi-vest">
            
            <h2 class="none" style="font-family:'acumin-pro-wide'; text-transform:uppercase; font-weight:400; font-size: max(36px, 2.8vw); line-height:50px;">HIGH-VISIBILITY VESTS</h2>
            <p class="main" >
                High-Visibility Vests offer many variations in order to best fit a working environment. The PIP difference is in the details, with quality materials and craftsmanship at every price point.
            </p>

            <div id="vest-details">
                <img  id="vest-img" src="/images/st-learning/hi-vis/img-exp-vests-difference.jpg" alt="hi-visibility vests" usemap="#vests" border="0"/>
                <map name="vests" id="vests">
                    <area shape="rect" coords="132,271,167,306" id="silver" ref="silver" style="cursor:help;"  @mouseover="hiVisVestHover" @mouseout="hiVisVestUnhover"/>
                    <area shape="rect" coords="233,385,270,421" id="hookloop" ref="hookloop" style="cursor:help;"  @mouseover="hiVisVestHover" @mouseout="hiVisVestUnhover"/>
                    <area shape="rect" coords="290,166,325,203" id="solid" ref="solid" style="cursor:help;"  @mouseover="hiVisVestHover" @mouseout="hiVisVestUnhover"/>
                    <area shape="rect" coords="506,191,542,227" id="mesh" ref="mesh" style="cursor:help;" @mouseover="hiVisVestHover" @mouseout="hiVisVestUnhover"/>
                    <area shape="rect" coords="682,325,719,362" id="zipper" ref="zipper" style="cursor:help;"  @mouseover="hiVisVestHover" @mouseout="hiVisVestUnhover"/>
                    <area shape="rect" coords="782,183,819,220" id="twotone" ref="twotone" style="cursor:help;" @mouseover="hiVisVestHover" @mouseout="hiVisVestUnhover"/>
                </map>
                <div id="vest-items">
                    <div id="silver-info" ref="silver-info">
                        <img src="/images/st-learning/hi-vis/img-exp-silver-tape.jpg" width="276" height="122" /><br />
                        <p class="space" style="padding:20px;">
                            <strong>Silver Reflective</strong><br />
                            When light shines on the retro-reflective material, it reflects back. Our garments use Level 2 Silver Reflective, which functions to a higher standard.
                        </p>
                    </div>

                    <div id="hookloop-info" ref="hookloop-info">
                        <img src="/images/st-learning/hi-vis/img-exp-hook-loop.jpg"  width="276" height="122"  /><br />
                        <p class="space" style="padding:20px;">
                            <strong>Hook & Loop Closure</strong><br />
                            Simple closure that is quick to open if needed.
                        </p>
                    </div>

                    <div id="solid-info" ref="solid-info">
                        <img src="/images/st-learning/hi-vis/img-exp-solid-tricot.jpg" width="276" height="122"  /><br />
                        <p class="space" style="padding:20px">
                            <strong>Solid Polyester Tricot</strong><br />
                            Durable and soft, tricot fabric can easily stand up to daily wear and tear, but is still lightweight and breathable.
                        </p>
                    </div>

                    <div id="mesh-info" ref="mesh-info">
                        <img src="/images/st-learning/hi-vis/img-exp-mesh.jpg" width="276" height="122" /><br />
                        <p class="space" style="padding:20px;">
                            <strong>Mesh</strong><br />
                            Made from a durable polyester, mesh gives a great deal of breathability to the garment.
                        </p>
                    </div>

                    <div id="zipper-info" ref="zipper-info">
                    <img src="/images/st-learning/hi-vis/img-exp-zipper.jpg"  width="276" height="122" /><br />
                    <p class="space" style="padding:20px;">
                        <strong>Zipper Closure</strong><br />
                        Zippers that end at the bottom of the vest create less of a catch hazard than those that end a few inches above the bottom seam.
                    </p>
                    </div>

                    <div id="twotone-info" ref="twotone-info">
                        <img src="/images/st-learning/hi-vis/img-exp-two-tone.jpg"  width="276" height="122" /><br />
                        <p class="space" style="padding:20px;">
                            <strong>Two Tone Reflective</strong><br />
                            The addition of contrasting colored tape around silver reflective provides optimal visibility.
                        </p>
                    </div>
                </div>
            </div>

        </div>

        <div class="expert-div">

            <h2 class="space">Vest Styles</h2>
            <p class="main" >
            Using the basic components and requirements, vests are tailored for every jobsite's needs, from the basic everyday to premium, specialized functions with today's technology in mind.
            </p>

            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-vest-breakaway.jpg" width="276" height="400" alt="breakaway hi-vis vest" />
                        <p>
                            <strong>BREAKAWAY</strong><br />
                            For additional safety around extreme traffic hazards, moving machinery or equipment, these vests have a five point breakaway system in order to quickly remove the vest.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-vest-surveyors.jpg" width="276" height="400" alt="surveyors hi-vis vest" />
                        <p>
                            <strong>SURVEYORS</strong><br />
                            Surveyors vests take functionality to the next level, with specialized pockets to accomodate tablets, phones, maps and other equipment needed on the jobsite.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-vest-fr.jpg" width="276" height="400" alt="limited flammability hi-vis vest" />
                        <p>
                            <strong>LIMITED FLAMMABILITY</strong><br />
                            These treated vests are designed to prevent afterflame for up to 25 washes. When a flame source is removed from the material, it will self extinguish.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-vest-expandable.jpg" width="276" height="400" alt="expandable hi-vis vest" />
                        <p>
                            <strong>EXPANDABLE</strong><br />
                            Adjustable hook and loop closure at the sides create a comfortable and universal fit.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-vest-value.jpg" width="276" height="400" alt="everyday value hi-vis vest" />
                        <p>
                            <strong>EVERYDAY VALUE</strong><br />
                            Basic vests at an economic price point, with convenient pockets to keep equipment and devices convenient and secure.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-vest-ar.jpg" width="276" height="400" alt="ARC rated hi-vis vest" />
                        <p>
                            <strong>ARC RATED</strong><br />
                            Arc Rated, Flame Resistant vests that are meant to be worn over AR/FR clothing. No melt/no drip modacrylic fabrics, hook and loop closure, and reflective tape and binding allow the garments to resist ignition and self extinguish.
                        </p>  
                    </div>
                </VueSlickCarousel>
            </div>
            <!-- <p class="expert-link">
                <a href="https://www.amazon.com/stores/page/543ACA2A-20AE-4A4A-800E-BB61C4257567/search?ingress=2&visitId=d819cc99-3044-4077-8512-7e9ab5cfb075&ref_=ast_bln&terms=hi%20vis%20vest">View all High-Visibility Clothing products > </a>
            </p> -->

        </div>

        <img src="/images/st-learning/tic-divider-gray.gif"  class="expert-divider"/>

        <div class="expert-div">

            <h2 class="none" style="font-family:'acumin-pro-wide'; text-transform:uppercase; font-weight:400; font-size: max(36px, 2.8vw) line-height:50px;">HIGH-VISIBILITY T-SHIRTS</h2>

            <p class="main" >
                High-Visibility t-shirts are a lightweight and comfortable alternative or addition to just wearing a vest. Available in both short and long sleeve options, workers can still attain up to a Class 3 requirement wearing a garment that they may be less likely to remove during the work day. All of PIP's shirts are made with a breathable Birdseye Mesh to keep workers safe and in compliance.
            </p>

            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-tshirt-black.jpg" width="276" height="400" alt="black bottom hi-vis t-shirt" />
                        <p>
                            <strong>BLACK BOTTOM</strong><br />
                            The addition of black fabric on the front side helps to hide daily dirt and grime while maintaining ANSI compliance. PIP's Black Bottom T-Shirts are also enhanced with 50+ UV sun protection
                        </p>   
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-tshirt-twotone.jpg" width="276" height="400" alt="optimal visibility hi-vis t-shirt" />
                        <p>
                            <strong>OPTIMAL VISIBILITY</strong><br />
                            Styles are available with two tone tape, x-back or silver reflective tape in ANSI Class 2 or 3.
                        </p>   
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-tshirt-nonansi.jpg" width="276" height="400" alt="ANSI compliant material hi-vis t-shirt" />
                        <p>
                            <strong>ANSI COMPLIANT MATERIAL</strong><br />
                            Non-ANSI shirts made with ANSI compliant hi-visibility fabric, for a strong presence though they are not ANSI rated.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <!-- <p class="expert-link">
                <a href="https://www.amazon.com/stores/page/543ACA2A-20AE-4A4A-800E-BB61C4257567/search?ingress=2&visitId=d819cc99-3044-4077-8512-7e9ab5cfb075&ref_=ast_bln&terms=hi%20vis%20shirt">View all High-Visibility Clothing products ></a>
            </p> -->
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider"/>

        <div class="expert-div">

            <h2 class="space">The Dangers of Cold Stress</h2>


            <p class="main">
                <strong>LOW TEMPERATURE + WIND SPEED + WETNESS = INJURIES &amp; ILLNESS</strong><br />
                When the body is unable to warm itself, serious cold related illnesses and injuries may occur, and permanent tissue damage and death may result. Hypothermia can occur when land temperatures are above freezing or water temperatures are below 98.6°F / 37°C. Cold related illnesses can slowly overcome a person who has been chilled by low temperatures brisk winds, or wet clothing.
            </p>

            <div class="expert-cold-stress">
                <div>
                    <img src="/images/st-learning/hi-vis/img-exp-cold-stress---en.jpg" alt="cold stress dangers chart" />
                </div>
                <div>
                    <p>
                    <strong style="color:#000;">KEEPING WORKERS WARM</strong><br />
                    In order to stay warm it is important that work garments performand remain adaptive to the work environment, activity, and duration. Important factors to consider:
                    </p>
                    <br />
                    <ul id="cold-stress">
                    <li style="margin-bottom:10px;">
                        The wind resistance of the <strong>outer shell</strong> is critical, as it helps minimize the entrance of the denser cold air which would take the place of the warm air that is layered close to the body. High quality outer shells provide the desired resistance against wind and water, but also allow sweat to evaporate.
                    </li>
                    <li style="margin-bottom:10px;">
                    Adding lofted or fleece <strong>insulation</strong> provides a layer that traps the warmer air beneath the shell and helps keep out the cold.</li>
                    <li style="margin-bottom:10px;">
                    Keeping dry also allows the worker to stay as warm as possible. Whether it’s precipitation or water penetrating from the outside, or sweat generated by the worker, moisture can accelerate the effects of the cold environment and restrain the insulation’s efficiency.
                    </li>
                    <li style="margin-bottom:10px;">
                        In extremely cold conditions, it is better to <strong>dress in layers</strong> as opposed to wearing a jacket or coat with very thick lofts. The thicker lofts will restrict movement, which in turn means less body heat is generated. The proper insulation combined with fleece sweaters and wicking under-layers will provide optimal protection while remaining functional for the worker.
                        </li>
                    <li style="margin-bottom:10px;">
                        The ability to <strong>remove layers</strong> and/or jacket linings becomes critical when there is a wide temperature differential. This will help reduce the risk of excessive wetness from sweating while still providing adequate cold protection in this environment
                    </li>
                    </ul>
                </div>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider"/>

        <div class="expert-div">

            <h2 class="none" style="font-family:'acumin-pro-wide'; text-transform:uppercase; font-weight:400; font-size: max(36px, 2.8vw) line-height:50px;">HIGH-VISIBILITY SWEATSHIRTS</h2>

            <p class="main">
                Cold weather protection is still important in warmer climates, but overprotection is also a serious and potentially overlooked issue. When workers perspire, it can actually accelerate the effects of the cold environments and potentially affect their health and safety. Sweatshirts provide the same advantage as t-shirts, providing Class 3 protection as a comfortable piece of clothing, which may be much more practical than contricting workers with a vest stretched across multiple bulky layers of clothing.
            </p>

            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-sweatshirt-black.jpg" width="276" height="400" alt="black bottom hi-vis sweatshirt" />
                        <p>
                            <strong>BLACK BOTTOM</strong><br />
                            The addition of black fabric on the front side helps to hide daily dirt and grime while maintaining ANSI compliance. PIP's Black Bottom Sweatshirts also feature a waterproof outer shell.
                        </p>   
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-sweatshirt-pullover.jpg" width="276" height="400" alt="ANSI 3 compliant sweatshirt" />
                        <p>
                            <strong>MAINTAIN COMPLIANCE</strong><br />
                            Styles are available with two tone tape or silver reflective tape and are ANSI Class 3 compliant.
                        </p>   
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-sweatshirt-zip.jpg" width="276" height="400" alt="multiple styles of hi-vis sweatshirts"/>
                        <p>
                            <strong>MULTIPLE STYLES</strong><br />
                            Choose between pullover, zip-up or quarter zip closure, and hooded or crewneck.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <!-- <p class="expert-link">
                <a href="https://www.amazon.com/stores/page/543ACA2A-20AE-4A4A-800E-BB61C4257567/search?ingress=2&visitId=d819cc99-3044-4077-8512-7e9ab5cfb075&ref_=ast_bln&terms=hi%20vis%20sweatshirt">View all High-Visibility Clothing products ></a>
            </p> -->
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider"/>

        <div class="expert-div">

            <h2 class="none" id="expert-h2-heading">HIGH-VISIBILITY JACKETS &amp; COATS</h2>

            <p class="main" >
                High-Visibility outerwear provides the cold protection and versatility workers need to help them stay warm without hindering their ability to perform the task at hand. The PIP difference in our materials is quality. Thick 300D polyester shells create a strong and durable barrier against the elements, where others may cut costs at lower weight material. Paired with insulation options that are dense and warm but do not add constricting bulk, workers will be prepared to beat the cold.
            </p>

            <h2 class="space" style="margin-top:40px;">Shell &amp; Liner Materials</h2>
                <div id="jackets-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-ripstop.jpg" alt="rip stop fabric" />
                        <p>
                            <strong>RIP STOP</strong><br />
                            Reinforcement threads are interwoven at regular intervals in a crosshatch pattern, making it resistant to tearing and ripping. It is also coated to create a waterproof barrier.
                        </p>   
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-polyester.jpg" alt="coated polyester fabric" />
                        <p>
                            <strong>COATED POLYESTER</strong><br />
                            Durable polyester creates a barrier against the cold and wind. PVC can be used as a coating, but tends to make the garment stiff. Our garments use polyurethane, which allows the jackets to be more flexible and comfortable.
                        </p>   
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-fleece-insulation.jpg" alt="removable fleece liner" />
                        <p>
                            <strong>REMOVABLE FLEECE LINER</strong><br />
                            Polyester fleece is a versatile fabric that provides warmth and have quick drying properties. Being able to remove the liner helps keep workers at the right temperature without the risk of sweating.
                        </p>
                    </div> 
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-quilted-insulation.jpg" alt="hi-loft fiberfill insulation" />
                        <p>
                            <strong>HI-LOFT FIBERFILL INSULATION</strong><br />
                            A built-in insulation that resists water absorption and is quilted to resist migration.
                        </p>
                    </div> 
                </VueSlickCarousel>
            </div>


        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider"/>

        <div class="expert-div" style="border-bottom:none;">

            <h2 class="space">Jacket &amp; Coat Styles</h2>

            <p class="main" ></p>

            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-jacket-bomber.jpg" width="276" height="400" alt="bomber jacket" />
                        <p>
                            <strong>BOMBER JACKETS</strong><br />
                            Elastic-bottomed outerwear that hits below the waist.
                        </p>   
                    </div>
                    <div>
                        <img src="/images/st-learning/hi-vis/img-exp-coat.jpg" width="276" height="400" alt="winter coats" />
                        <p>
                            <strong>WINTER COATS</strong><br />
                            Longer, straight bottomed garments that go to the top of the thighs or below.
                        </p>   
                    </div>
                    <div>

                        <img src="/images/st-learning/hi-vis/img-exp-coat-all.jpg" width="276" height="400" alt="all conditions coat" />
                        <p>
                            <strong>ALL CONDITIONS COATS</strong><br />
                            Offer multiple combinations to adjust to the weather, with inner garments that can be worn as stand-alone or combined pieces.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>
            <!-- <p class="expert-link">
                <a href="https://www.amazon.com/stores/page/543ACA2A-20AE-4A4A-800E-BB61C4257567/search?ingress=2&visitId=d819cc99-3044-4077-8512-7e9ab5cfb075&ref_=ast_bln&terms=hi%20vis%20jacket">View all High-Visibility Clothing products ></a>
            </p> -->

        </div>

    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";
    import "vue-slick-carousel/dist/vue-slick-carousel.css";
    import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
    export default {
        data() {
            return {
            name: 'Vue.js',
            settings: {
                  "autoplay": false,
                  "focusOnSelect": true,
                  "infinite": false,
                  "pauseOnFocus": true,
                  "slidesToShow": 3,
                  "speed": 500,
                  "arrows":true,
                  responsive: [
                      {
                      breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                      },
                      {
                      breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                      }
                    ]
                }
            }
        },

        methods: {
            hiVisVestHover(event) {
                if (event) {
                    var hoveredID = event.target.id + "-info";
                    this.$refs[hoveredID].style="display: block;";
                }
            },
            hiVisVestUnhover(event) {
                if (event) {
                    var hoveredID = event.target.id + "-info";
                    this.$refs[hoveredID].style="display: none;";
                }
            },
            showMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: block;";
                    this.$refs['readMore'].style="display: none;";
                    this.$refs['readLess'].style="display: block;";
                }
            },
            hideMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: none;";
                    this.$refs['readMore'].style="display: block;";
                    this.$refs['readLess'].style="display: none;";
                }
            },
            burgerClicked(event) {
                if (event) {
                    if (this.$refs['gloveDropdown'].style.display != "block") {
                        this.$refs['gloveDropdown'].style="display: block;";
                    } else {
                        this.$refs['gloveDropdown'].style="display: none;";
                    }
                }
            }
        },
        components: { VueSlickCarousel }
    }

</script>
